export const FUTURE_NIGHTS_PAGE_SIZE = 3;
export const PAST_NIGHTS_PAGE_SIZE = 4;
